module.exports = __webpack_public_path__ + "static/ms-icon-144x144-8f101e480907a50b31a6c6dff09557b1.png";